
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Web-Elements/Notification.html",
      function () {
        return require("private-next-pages/Web-Elements/Notification.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Web-Elements/Notification.html"])
      });
    }
  